/**
 * The legacy `GiveawayStore` rules: every time a stand tab loads, an icon shows
 * up half of the time, picked at random, and leaves after ten seconds.
 */
export const DROP_CHANCE = 0.5;
export const DROP_VISIBLE_MS = 10_000;

export function pickDrop<T>(
  icons: readonly T[],
  random: () => number = Math.random,
): T | undefined {
  if (icons.length === 0 || random() >= DROP_CHANCE) {
    return undefined;
  }

  return icons[Math.floor(random() * icons.length)];
}
